import React, {Component} from 'react'
import {Icon, Menu} from 'semantic-ui-react'
import UserMenu from './userMenu'
import {isMobile} from "../utils/utils";

class FullScreenPageMenu extends Component {
    render() {
        const {onBack, center, user, useMobileStyles} = this.props;
        let centerStyles = { width: '34%', textAlign: 'center', lineHeight: '44px', fontWeight: 'bold'};

        if(useMobileStyles && isMobile()){
            centerStyles = { width: '75%', textAlign: 'center'};
        }

        return (
            <React.Fragment>
                <Menu fixed='top' secondary pointing className="member-menuContainer">
                    <div style={{ width: '33%'}}>
                        {onBack && (
                            <Icon
                                link
                                name="left arrow"
                                onClick={onBack}
                                style={{ padding: '10px 18px' }}
                            />
                        )}
                    </div>
                    {center && (
                        <div style={centerStyles}>
                            {center}
                        </div>
                    )}
                    <UserMenu user={user} />
                </Menu>
                <div className={"member-header-shadow"}/>
            </React.Fragment>
        )
    }
}

export default FullScreenPageMenu;